export default __webpack_public_path__ + "static/media/experience.f91bd704.png";